import { render, staticRenderFns } from "./AlbumImage.vue?vue&type=template&id=ad7c9f02&scoped=true"
import script from "./AlbumImage.vue?vue&type=script&lang=js"
export * from "./AlbumImage.vue?vue&type=script&lang=js"
import style0 from "./AlbumImage.vue?vue&type=style&index=0&id=ad7c9f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7c9f02",
  null
  
)

export default component.exports